import React, {Component} from "react";
import {Get} from "../../api/Post";
import FooterMobile from '../../FooterMobile';
import CreateOrder from "../CreateOrder";
import Welcome from "../../img/welcomeImage.png";
import WelcomeMobile from "../../img/welcomeMobile.png";
import {ReactComponent as Copy} from "../../img/copy.svg";
import Tmall from '../../img/tmall.png';
import Shop1688 from '../../img/1688.png';
import Alibaba from '../../img/alibaba.png';
import WeChat from '../../img/wechat.png';
import Taobao from '../../img/taobao.png';
import {withStyles} from '@material-ui/core/styles';
import { translate } from "../../dictionaries";

const classes = () => ({
    welcome: {
        '@media (max-width: 1024px)': {
            display: 'none'
          }
    },
    welcomeMobile: {
        display: 'none',
        '@media (max-width: 1024px)': {
            display: 'block'
          }
    }
})

class Post extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isExist: false,
            isOrder: false,
            html: "",
            name: "",
            phone: false,
        };

    }

    componentDidMount() {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.setState({
                phone: true
            })
          } else {
            this.setState({
                phone: false
            })
        }
        this.loadPost();
    }

    updateState(model) {
        this.setState(model);
    }

    getCurrent = async (menu) => {
        menu.forEach(async (item) => {
            
            if (("/" + item.href === decodeURIComponent(window.location.pathname)) && !this.state.isExist) {
                if (item.id === 1) {

                    this.updateState({
                        isExist: true,
                        isOrder: true,
                    })
                } else {
                    
                    const resp = await Get(item.id);

                    if (resp.status === 200) {
                        const data = await resp.json();

                        this.updateState({
                            isOrder: false,
                            isExist: true,
                            html: data.html,
                            russianName: item.russianName,
                            englishName: item.englishName,
                            chinaName: item.chinaName
                        })
                    }
                }
            }else {
                if(decodeURIComponent(window.location.pathname) === "/LIChNYYKABINET/Kakoformitzakaznavykupskitayskikhsaytov" && !this.state.isExist){
                    if(item.href === "lichnyy_kabinet/kak_oformit_zakaz_na_vykup_s_kitayskikh_saytov"){
                        const resp = await Get(item.id);

                        if (resp.status === 200) {
                            const data = await resp.json();

                            this.updateState({
                                isOrder: false,
                                isExist: true,
                                html: data.html,
                                russianName: item.russianName,
                                englishName: item.englishName,
                                chinaName: item.chinaName
                            })
                        }
                    }
                } else if(decodeURIComponent(window.location.pathname) === "/LIChNYYKABINET/KakrasschitatstoimostdostavkiizKitaya" && !this.state.isExist){
                    if(item.href === "lichnyy_kabinet/kak_rasschitat_stoimost_dostavki_iz_kitaya"){
                        const resp = await Get(item.id);

                        if (resp.status === 200) {
                            const data = await resp.json();

                            this.updateState({
                                isOrder: false,
                                isExist: true,
                                html: data.html,
                                russianName: item.russianName,
                                englishName: item.englishName,
                                chinaName: item.chinaName
                            })
                        }
                    }
                }
            }

            this.getCurrent(item.items);
        })
    };


    loadPost = () => {
        this.getCurrent(this.props.menu);
    };

    render() {
        
        
        const {classes} = this.props;
        return (
            <>
                <div className="site__content" style={{marginTop: this.props.showBanner && !this.state.phone ? 85 : 0}}>
                    {
                        window.location.pathname === '/' && 
                        <div style={{marginTop: 100, width: 821}} className={classes.welcome}>
                            <img src={Welcome} style={{marginBottom: 35}}/> 

                            <div style={{display: 'flex', width: 758, margin: '0 auto', marginLeft: 50, justifyContent: 'space-between'}}>
                                <img src={Taobao} alt="" style={{width: '15%', height: '15%'}}/>
                                <img src={Shop1688} alt="" style={{width: '15%', height: '15%'}}/>
                                <img src={Alibaba} alt="" style={{width: '15%', height: '15%'}}/>
                                <img src={Tmall} alt="" style={{width: '15%', height: '15%'}}/>
                                <img src={WeChat} alt="" style={{width: '15%', height: '15%'}}/>
                            </div> 
                        </div>
                    }
                    {
                        window.location.pathname === '/' && 
                        <div style={{height: '100%', width: '100%', paddingTop: 47}} className={classes.welcomeMobile}>
                            <div style={{width: 305, margin: '0 auto'}}>
                                <h3 style={{margin: 0, padding: 0, color: '#000000', fontFamily: 'Calibri, sans-serif', fontSize: 26, fontWeight: 700, lineHeight: '30px', textTransform: 'uppercase',}}>{translate('common.hello')}</h3>
                                <p style={{margin: '11px 0 28px', padding: 0, color: '#000000', fontFamily: 'Calibri, sans-serif', fontSize: 16, fontWeight: 300, lineHeight: '20px'}}>
                                    <div dangerouslySetInnerHTML={{__html: translate('common.faq')}} /> <span style={{textTransform: 'uppercase'}}>topzakazz logistics</span>
                                </p>
                            </div>
                            <img src={WelcomeMobile} style={{display: 'flex', margin: '0 auto 35px'}}/> 
                            <p style={{
                                display: 'flex',
                                color: '#333333',
                                fontFamily: 'Calibri',
                                fontSize: 16,
                                fontWeight: 300,
                                lineHeight: '22px',
                                width: 305,
                                margin: '0 auto 30px'

                            }}>
                                {translate('common.instruction')}
                            </p>
                            <div style={{display: 'flex', flexWrap: 'wrap', width: 305, margin: '0 auto', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20}}>
                                <div>
                                    <img src={Taobao} alt="" style={{width: 80, marginRight: 30}}/>
                                    <img src={Shop1688} alt="" style={{width: 80, marginRight: 30}}/>
                                    <img src={Alibaba} alt="" style={{width: 80}}/>
                                </div>
                                <div style={{width:210, margin: '0 auto'}}>
                                    <img src={Tmall} alt="" style={{width: 80, marginRight: 30}}/>
                                    <img src={WeChat} alt="" style={{width: 80}}/>
                                </div>
                            </div> 
                        </div>
                    }
                    {
                        this.state.isExist &&
                        <section className={"content"}>
                            {
                                this.state.isOrder &&
                                <CreateOrder/>
                                
                            }
                            {
                                !this.state.isOrder &&
                                <>
                                    <h1 className="content__title  content__title--icon">
                                        <b>
                                        {
                                            (!localStorage.getItem('language') || localStorage.getItem('language') === 'ru') && this.state.russianName
                                        }
                                        {
                                            localStorage.getItem('language') === 'en' && this.state.englishName
                                        }
                                        {
                                            localStorage.getItem('language') === 'zh' && this.state.chinaName
                                        }
                                        </b>
                                    </h1>
                                    <div className={"content__box"} style={{display: "flex"}}>
                                        <div className={"content_post"}
                                             dangerouslySetInnerHTML={{__html: this.state.html}}>
                                        </div>
                                    </div>
                                </>
                            }
                            
                            <div className="footer-mobile">
                                <FooterMobile />
                            </div>
                        </section>
                    }
                </div>
            </>
        )
    }
}

export default withStyles(classes)(Post);